import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Icon from "@jll/icon";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "./styles";

const TopNavigation = ({
  classes,
  theme,
  leftItems,
  rightItems,
  className,
  containerElement,
  fixed,
  logoType,
  productName,
  onLogoClick,
  ...other
}) => {
  const topNavigationClass = cx(
    classes.topNavigation,
    {
      [classes.topNavigationDark]: theme === "dark",
      [classes.topNavigationTransparent]: theme === "transparent",
      [classes.topNavigationFixed]: fixed === true,
    },
    className
  );

  const topNavLeftItems = leftItems.map((item, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <div key={index} className={classes.navItem}>
      {item}
    </div>
  ));
  const topNavRightItems = rightItems.map((item, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <div key={index} className={classes.navItem}>
      {item}
    </div>
  ));

  const renderFullLogo = (
    <button className={classes.navLogoWrapper} type="button" onClick={onLogoClick}>
      <Icon type="jll" name="jll-logo-regular" height={32} width={71} variation={logoType} />
      <h3
        className={cx(classes.navTitle, {
          [classes.navTitleDark]: theme === "dark",
        })}
      >
        {productName}
      </h3>
    </button>
  );

  const Element = containerElement || "div";

  return (
    <Element className={topNavigationClass} {...other}>
      <div className={classes.navLeftItems}>
        {renderFullLogo}
        {topNavLeftItems}
      </div>
      <div className={classes.navRightItems}>{topNavRightItems}</div>
    </Element>
  );
};

TopNavigation.propTypes = {
  className: PropTypes.string,
  containerElement: PropTypes.string,
  leftItems: PropTypes.arrayOf(PropTypes.node),
  logoType: PropTypes.oneOf(["", "black", "white"]),
  onLogoClick: PropTypes.func,
  productName: PropTypes.string,
  rightItems: PropTypes.arrayOf(PropTypes.node),
  fixed: PropTypes.bool,
  theme: PropTypes.oneOf(["", "light", "dark", "transparent"]),
};

TopNavigation.defaultProps = {
  className: "",
  containerElement: "",
  fixed: false,
  leftItems: [],
  logoType: "",
  onLogoClick: undefined,
  productName: "",
  rightItems: [],
  theme: "",
};

export default withStyles(styles)(TopNavigation);
